import { defineStore } from "pinia";
import { showError } from "src/utils/notify";
import { sortListingByDate } from "src/utils/dateHelper";
import { groupListingByKey } from "src/utils";
import {
  KlaviyoEventTypes,
  useklaviyoEventsStores,
} from "./klaviyo-events-store";

export const useDealDetails = defineStore("mydeals", {
  state: () => ({
    earningHistory: {},
    loadHistory: false,
    coupons: [],
    loadCoupons: false,
    deals: [],
    loadDeals: false,
    storeFilter: [],
    loadStoreFilter: false,
    allDeals: [],
    loadAllDeals: false,
    dashboardDeals: [],
    dashboardDealsLoad: false,
  }),
  getters: {
    couponsList: (state) => {
      return state.coupons;
    },
    customerDeals: (state) => {
      return groupListingByKey(state.deals, "account.id");
    },
  },
  actions: {
    async getEarningHistory(params) {
      try {
        if (params.page == 1) {
          this.resetEarningHistory();
        }
        let response = await this.$request.get(
          this.apiEndpoints.EARNING_HISTORY(
            params.campaign_id,
            params.page,
            params.per_page
          )
        );
        if (response.data) {
          if (params.page == 1) {
            this.earningHistory = {};
            this.loadHistory = false;
          }
          const historyData = JSON.parse(JSON.stringify(this.earningHistory));
          const sortData = sortListingByDate(response.data.items || []);
          for (let date in sortData) {
            if (date in historyData)
              historyData[date] = [...historyData[date], ...sortData[date]];
            else historyData[date] = sortData[date];
          }
          this.earningHistory = historyData;
          this.loadHistory = true;
        }
        return response.data;
      } catch (error) {
        // console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    async getCustomerDeals() {
      try {
        let response = await this.$request.get(
          this.apiEndpoints.CUSTOMER_DEALS
        );
        if (response.data) {
          this.deals = response.data.items || [];
          this.loadDeals = true;
        }
        return response.data;
      } catch (error) {
        // console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    resetEarningHistory() {
      this.earningHistory = {};
      this.loadHistory = false;
    },
    async getCouponsList() {
      try {
        this.coupons = [];
        this.loadCoupons = false;
        let response = await this.$request.get(
          this.apiEndpoints.COUPONS_LIST("?includemfg=1")
        );
        if (response.data && response.data.items) {
          this.coupons = [];
          if (response.data.items.stores) {
            Array.prototype.push.apply(
              this.coupons,
              response.data.items.stores
            );
          }
          if (response.data.items.mfg) {
            Array.prototype.push.apply(this.coupons, response.data.items.mfg);
          }
        }
        this.loadCoupons = true;
        return response.data;
      } catch (error) {
        // console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    async getDealDetails(id) {
      try {
        let data = await this.$request.get(
          this.apiEndpoints.CAMPAIGNS_DETAILS(id)
        );
        if (data.data && data.data.status) {
          return data.data;
        } else {
          return data.data;
        }
      } catch (error) {
        return { status: false, message: error.message };
      }
    },

    async getFilterStoreList(type) {
      try {
        this.storeFilter = [];
        this.loadStoreFilter = false;

        let response = await this.$request.get(
          this.apiEndpoints.GET_FILTER_LIST_DEAL(type)
        );
        if (response.data) {
          // console.log(response);
          this.storeFilter = response.data.items || [];
          if (this.storeFilter?.length) {
            this.storeFilter.unshift({ id: "-1", company: "All" });
          }
          this.loadStoreFilter = true;
        }
        return response.data;
      } catch (error) {
        // console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    resetDeals() {
      this.allDeals = [];
      this.loadAllDeals = false;
    },
    async getAllDeals(param) {
      try {
        if (!param.includes("page")) {
          this.resetDeals();
        }

        let response = await this.$request.get(
          this.apiEndpoints.ALL_DEALS(param)
        );
        if (response.data) {
          if (param.includes("page=1&")) {
            this.resetDeals();
            this.allDeals = response?.data?.items ? response?.data?.items : [];
          } else {
            Array.prototype.push.apply(
              this.allDeals,
              response?.data?.items ? response?.data?.items : []
            );
          }
        }
        this.loadAllDeals = true;
        return response.data;
      } catch (error) {
        // console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    async registerStoreDeal(id) {
      try {
        let response = await this.$request.get(
          this.apiEndpoints.CAMPAIGNS_REGISTER_STORE(id)
        );
        return response.data;
      } catch (error) {
        return {
          status: false,
          message: "An unknown error occurred. Please try again later.",
        };
        showError(error.message);
      }
    },
    async registerMFGDeal(id) {
      try {
        let response = await this.$request.get(
          this.apiEndpoints.CAMPAIGNS_REGISTER_MFG(id)
        );
        return response.data;
      } catch (error) {
        return {
          status: false,
          message: "An unknown error occurred. Please try again later.",
        };
        showError(error.message);
      }
    },
    async getSingleDealDetails(id, type) {
      try {
        let response = await this.$request.get(
          this.apiEndpoints.SIGNLE_DEAL_DETAILS(id, type)
        );
        const klaviyoStore = useklaviyoEventsStores();
        if (type != "MFG" && response?.data?.item?.account_id)
          klaviyoStore.addKlaviyoEvent({
            event_name: KlaviyoEventTypes.VIEWED_CAMPAIGN,
            store_id: response.data.item.account_id,
            deal_id: id,
          });
        return response.data;
      } catch (error) {
        return {
          status: false,
          message: "An unknown error occurred. Please try again later.",
        };
        showError(error.message);
      }
    },
    async getDashboardDeals(param) {
      try {
        this.resetDashboardDeals();
        let response = await this.$request.get(
          this.apiEndpoints.DASHBOARD_CAMPAIGNS(param)
        );
        this.dashboardDealsLoad = true;
        if (response.data && response.data.status && response?.data?.items) {
          this.dashboardDeals = response?.data?.items;
        }
        return response.data;
      } catch (error) {
        showError(error.message);
      }
    },
    async resetDashboardDeals() {
      this.dashboardDeals = [];
      this.dashboardDealsLoad = false;
    },
  },
});
